import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="admin"
export default class extends Controller {
  static targets = ["checkbox", "amountInput"];

  declare checkboxTargets: HTMLInputElement[];
  declare hasCheckboxTarget: boolean;
  declare amountInputTarget: HTMLInputElement;
  declare hasAmountInputTarget: boolean;

  connect() {}

  updateRequestAmount() {
    if (!this.hasAmountInputTarget) return;

    let total = 0.0;
    this.checkboxTargets.forEach((element) => {
      if (element.checked) {
        total += parseFloat(element.dataset.amount);
      }
    });
    this.amountInputTarget.value = String(total);
  }
}
